import { createReducer, on } from "@ngrx/store"
import { FeeShare } from "./fee-sharing.interfaces"
import * as feeActions from './fee-sharing.actions';

export interface FeeState {
    feeShare: FeeShare[] | null
    feeShareError: boolean
    feeShareLoading: boolean
}
export const initialState: FeeState = {
    feeShare: null,
    feeShareError: null,
    feeShareLoading: null,
}
export const FeeReducer = createReducer(
    initialState,

    on(feeActions.fetchFeeShare, (state) => ({
        ...state, feeShare: null, feeShareError: null, feeShareLoading: true
    })),

    on(feeActions.fetchFeeShareSuccess, (state, {feeShare}) => ({
        ...state, feeShare: feeShare, feeShareError: false, feeShareLoading: false
    })),

    on(feeActions.fetchFeeShareFailed, (state) => ({
        ...state, feeShare: null, feeShareError: true, feeShareLoading: false
    })),
)